export default __webpack_public_path__ + "static/media/citizen-btn-2.429859b9.jpg";